export default async (context) => {
    let record = context.$store.getters['survey_price/id']

    await context.$axios.post('/calendar', {
        record: record
    })
        .then(({ data }) => {

            context.calendar = data
            context.statusCalendar = true

            context.$nextTick(() => {
                context.rendering = true
                context.overlay = true
                context.is_weather = true
            })

            context.overlay = false
            context.error.status = false
            context.error.text = ''

        })
        .catch(e => {
            console.error(e)
            context.error.text = 'Не удалось получить список дат. Повторите попытку позже.'
            context.overlay = true
            context.error.status = true
        })
}